import React from 'react';
import { LazyMotion, domAnimation } from 'framer-motion';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { BenefitsStrip } from './components/BenefitsStrip';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { TransformationSection } from './components/TransformationSection';
import { MethodSection } from './components/MethodSection';
import { ForWhoSection } from './components/ForWhoSection';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { InsideCarousel } from './components/InsideCarousel';
import { TestimonialsSection } from './components/TestimonialsSection';
import { TestimonialHighlight } from './components/TestimonialHighlight';
import { PricingCards } from './components/PricingCards';
import { ComparisonTable } from './components/ComparisonTable';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { useMetaPixel } from './hooks/useMetaPixel';
const META_PIXEL_ID = '2314996429237093';
export function App() {
  useMetaPixel();
  return <LazyMotion features={domAnimation} strict data-id="element-0" data-mp="2zl3alhpbj03q">
      <div className="min-h-full w-full bg-mp-black font-body" data-id="element-1" data-mp="2zmeowbge3q93">
        <noscript data-id="element-2" data-mp="33mf623uvifju">
          <img height={1} width={1} style={{
          display: 'none'
        }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-3" data-mp="33lx18iu5at0b" />
        </noscript>
        <main data-id="element-4" data-mp="3dirv2ofh4589">
          <Hero data-id="element-5" data-mp="3dii694660445" />
          <SocialProofBar data-id="element-6" data-mp="nvstj3irmlvf" />
          <BenefitsStrip data-id="element-7" data-mp="nuhhyhj2w9tr" />
          <TransformationSection data-id="element-8" data-mp="nvar1p5ifbf2" />
          <MethodSection data-id="element-9" data-mp="sunf2d84aoj8" />
          <ForWhoSection data-id="element-10" data-mp="studrrrxgr8h" />
          <TomosSection data-id="element-11" data-mp="st2iki28sviq" />
          <BonosSection data-id="element-12" data-mp="swgk5o3310p4" />
          <InsideCarousel data-id="element-13" data-mp="3688rpx40wyp" />
          <TestimonialsSection data-id="element-14" data-mp="35ghusegjner" />
          <TestimonialHighlight data-id="element-15" data-mp="38kxqn1ac7l9" />
          <PricingCards data-id="element-16" data-mp="3ud1en72ulk9k" />
          <ComparisonTable data-id="element-17" data-mp="3ubrgyizwqe3g" />
          <GuaranteeSection data-id="element-18" data-mp="3ucjdpx58qhvb" />
          <FAQSection data-id="element-19" data-mp="d4nvlgp3tk2e" />
          <FinalCTA data-id="element-20" data-mp="d4xp3e9cy9cu" />
        </main>
        <Footer data-id="element-21" data-mp="d45ua5nl4fnm" />
        <StickyMobileCTA data-id="element-22" data-mp="d2l7j27ii10b" />
        <PurchaseNotifications data-id="element-23" data-mp="85uk1ttdo34v" />
      </div>
    </LazyMotion>;
}